// extracted by mini-css-extract-plugin
export var modal = "_l5-0";